export const COUNTRIES = [
    {
      "id": 1,
      "name": "Afghanistan",
      "link": "/wettbewerbe/national/wettbewerbe/1"
    },
    {
      "id": 3,
      "name": "Albania",
      "link": "/wettbewerbe/national/wettbewerbe/3"
    },
    {
      "id": 4,
      "name": "Algeria",
      "link": "/wettbewerbe/national/wettbewerbe/4"
    },
    {
      "id": 239,
      "name": "American Samoa",
      "link": "/wettbewerbe/national/wettbewerbe/239"
    },
    {
      "id": 234,
      "name": "American Virgin Islands",
      "link": "/wettbewerbe/national/wettbewerbe/234"
    },
    {
      "id": 5,
      "name": "Andorra",
      "link": "/wettbewerbe/national/wettbewerbe/5"
    },
    {
      "id": 6,
      "name": "Angola",
      "link": "/wettbewerbe/national/wettbewerbe/6"
    },
    {
      "id": 232,
      "name": "Anguilla",
      "link": "/wettbewerbe/national/wettbewerbe/232"
    },
    {
      "id": 7,
      "name": "Antigua and Barbuda",
      "link": "/wettbewerbe/national/wettbewerbe/7"
    },
    {
      "id": 9,
      "name": "Argentina",
      "link": "/wettbewerbe/national/wettbewerbe/9"
    },
    {
      "id": 10,
      "name": "Armenia",
      "link": "/wettbewerbe/national/wettbewerbe/10"
    },
    {
      "id": 233,
      "name": "Aruba",
      "link": "/wettbewerbe/national/wettbewerbe/233"
    },
    {
      "id": 12,
      "name": "Australia",
      "link": "/wettbewerbe/national/wettbewerbe/12"
    },
    {
      "id": 127,
      "name": "Austria",
      "link": "/wettbewerbe/national/wettbewerbe/127"
    },
    {
      "id": 13,
      "name": "Azerbaijan",
      "link": "/wettbewerbe/national/wettbewerbe/13"
    },
    {
      "id": 14,
      "name": "Bahamas",
      "link": "/wettbewerbe/national/wettbewerbe/14"
    },
    {
      "id": 15,
      "name": "Bahrain",
      "link": "/wettbewerbe/national/wettbewerbe/15"
    },
    {
      "id": 16,
      "name": "Bangladesh",
      "link": "/wettbewerbe/national/wettbewerbe/16"
    },
    {
      "id": 17,
      "name": "Barbados",
      "link": "/wettbewerbe/national/wettbewerbe/17"
    },
    {
      "id": 18,
      "name": "Belarus",
      "link": "/wettbewerbe/national/wettbewerbe/18"
    },
    {
      "id": 19,
      "name": "Belgium",
      "link": "/wettbewerbe/national/wettbewerbe/19"
    },
    {
      "id": 20,
      "name": "Belize",
      "link": "/wettbewerbe/national/wettbewerbe/20"
    },
    {
      "id": 21,
      "name": "Benin",
      "link": "/wettbewerbe/national/wettbewerbe/21"
    },
    {
      "id": 211,
      "name": "Bermuda",
      "link": "/wettbewerbe/national/wettbewerbe/211"
    },
    {
      "id": 22,
      "name": "Bhutan",
      "link": "/wettbewerbe/national/wettbewerbe/22"
    },
    {
      "id": 23,
      "name": "Bolivia",
      "link": "/wettbewerbe/national/wettbewerbe/23"
    },
    {
      "id": 269,
      "name": "Bonaire",
      "link": "/wettbewerbe/national/wettbewerbe/269"
    },
    {
      "id": 24,
      "name": "Bosnia-Herzegovina",
      "link": "/wettbewerbe/national/wettbewerbe/24"
    },
    {
      "id": 25,
      "name": "Botswana",
      "link": "/wettbewerbe/national/wettbewerbe/25"
    },
    {
      "id": 26,
      "name": "Brazil",
      "link": "/wettbewerbe/national/wettbewerbe/26"
    },
    {
      "id": 276,
      "name": "British India",
      "link": "/wettbewerbe/national/wettbewerbe/276"
    },
    {
      "id": 231,
      "name": "British Virgin Islands",
      "link": "/wettbewerbe/national/wettbewerbe/231"
    },
    {
      "id": 27,
      "name": "Brunei Darussalam",
      "link": "/wettbewerbe/national/wettbewerbe/27"
    },
    {
      "id": 28,
      "name": "Bulgaria",
      "link": "/wettbewerbe/national/wettbewerbe/28"
    },
    {
      "id": 29,
      "name": "Burkina Faso",
      "link": "/wettbewerbe/national/wettbewerbe/29"
    },
    {
      "id": 30,
      "name": "Burundi",
      "link": "/wettbewerbe/national/wettbewerbe/30"
    },
    {
      "id": 79,
      "name": "Cambodia",
      "link": "/wettbewerbe/national/wettbewerbe/79"
    },
    {
      "id": 31,
      "name": "Cameroon",
      "link": "/wettbewerbe/national/wettbewerbe/31"
    },
    {
      "id": 80,
      "name": "Canada",
      "link": "/wettbewerbe/national/wettbewerbe/80"
    },
    {
      "id": 32,
      "name": "Cape Verde",
      "link": "/wettbewerbe/national/wettbewerbe/32"
    },
    {
      "id": 229,
      "name": "Cayman Islands",
      "link": "/wettbewerbe/national/wettbewerbe/229"
    },
    {
      "id": 138,
      "name": "Central African Republic",
      "link": "/wettbewerbe/national/wettbewerbe/138"
    },
    {
      "id": 171,
      "name": "Chad",
      "link": "/wettbewerbe/national/wettbewerbe/171"
    },
    {
      "id": 33,
      "name": "Chile",
      "link": "/wettbewerbe/national/wettbewerbe/33"
    },
    {
      "id": 34,
      "name": "China",
      "link": "/wettbewerbe/national/wettbewerbe/34"
    },
    {
      "id": 164,
      "name": "Chinese Taipei",
      "link": "/wettbewerbe/national/wettbewerbe/164"
    },
    {
      "id": 248,
      "name": "Christmas Island",
      "link": "/wettbewerbe/national/wettbewerbe/248"
    },
    {
      "id": 83,
      "name": "Colombia",
      "link": "/wettbewerbe/national/wettbewerbe/83"
    },
    {
      "id": 35,
      "name": "Comoros",
      "link": "/wettbewerbe/national/wettbewerbe/35"
    },
    {
      "id": 85,
      "name": "Congo",
      "link": "/wettbewerbe/national/wettbewerbe/85"
    },
    {
      "id": 238,
      "name": "Cookinseln",
      "link": "/wettbewerbe/national/wettbewerbe/238"
    },
    {
      "id": 36,
      "name": "Costa Rica",
      "link": "/wettbewerbe/national/wettbewerbe/36"
    },
    {
      "id": 38,
      "name": "Cote d'Ivoire",
      "link": "/wettbewerbe/national/wettbewerbe/38"
    },
    {
      "id": 278,
      "name": "Crimea",
      "link": "/wettbewerbe/national/wettbewerbe/278"
    },
    {
      "id": 37,
      "name": "Croatia",
      "link": "/wettbewerbe/national/wettbewerbe/37"
    },
    {
      "id": 220,
      "name": "CSSR",
      "link": "/wettbewerbe/national/wettbewerbe/220"
    },
    {
      "id": 88,
      "name": "Cuba",
      "link": "/wettbewerbe/national/wettbewerbe/88"
    },
    {
      "id": 260,
      "name": "Curacao",
      "link": "/wettbewerbe/national/wettbewerbe/260"
    },
    {
      "id": 188,
      "name": "Cyprus",
      "link": "/wettbewerbe/national/wettbewerbe/188"
    },
    {
      "id": 172,
      "name": "Czech Republic",
      "link": "/wettbewerbe/national/wettbewerbe/172"
    },
    {
      "id": 39,
      "name": "Denmark",
      "link": "/wettbewerbe/national/wettbewerbe/39"
    },
    {
      "id": 41,
      "name": "Djibouti",
      "link": "/wettbewerbe/national/wettbewerbe/41"
    },
    {
      "id": 42,
      "name": "Dominica",
      "link": "/wettbewerbe/national/wettbewerbe/42"
    },
    {
      "id": 43,
      "name": "Dominican Republic",
      "link": "/wettbewerbe/national/wettbewerbe/43"
    },
    {
      "id": 193,
      "name": "DR Congo",
      "link": "/wettbewerbe/national/wettbewerbe/193"
    },
    {
      "id": 222,
      "name": "East Germany (GDR)",
      "link": "/wettbewerbe/national/wettbewerbe/222"
    },
    {
      "id": 44,
      "name": "Ecuador",
      "link": "/wettbewerbe/national/wettbewerbe/44"
    },
    {
      "id": 2,
      "name": "Egypt",
      "link": "/wettbewerbe/national/wettbewerbe/2"
    },
    {
      "id": 45,
      "name": "El Salvador",
      "link": "/wettbewerbe/national/wettbewerbe/45"
    },
    {
      "id": 189,
      "name": "England",
      "link": "/wettbewerbe/national/wettbewerbe/189"
    },
    {
      "id": 8,
      "name": "Equatorial Guinea",
      "link": "/wettbewerbe/national/wettbewerbe/8"
    },
    {
      "id": 46,
      "name": "Eritrea",
      "link": "/wettbewerbe/national/wettbewerbe/46"
    },
    {
      "id": 47,
      "name": "Estonia",
      "link": "/wettbewerbe/national/wettbewerbe/47"
    },
    {
      "id": 162,
      "name": "Eswatini",
      "link": "/wettbewerbe/national/wettbewerbe/162"
    },
    {
      "id": 11,
      "name": "Ethiopia",
      "link": "/wettbewerbe/national/wettbewerbe/11"
    },
    {
      "id": 250,
      "name": "Falkland Islands",
      "link": "/wettbewerbe/national/wettbewerbe/250"
    },
    {
      "id": 208,
      "name": "Faroe Islands",
      "link": "/wettbewerbe/national/wettbewerbe/208"
    },
    {
      "id": 111,
      "name": "Federated States of Micronesia",
      "link": "/wettbewerbe/national/wettbewerbe/111"
    },
    {
      "id": 48,
      "name": "Fiji",
      "link": "/wettbewerbe/national/wettbewerbe/48"
    },
    {
      "id": 49,
      "name": "Finland",
      "link": "/wettbewerbe/national/wettbewerbe/49"
    },
    {
      "id": 50,
      "name": "France",
      "link": "/wettbewerbe/national/wettbewerbe/50"
    },
    {
      "id": 252,
      "name": "French Guiana",
      "link": "/wettbewerbe/national/wettbewerbe/252"
    },
    {
      "id": 51,
      "name": "Gabon",
      "link": "/wettbewerbe/national/wettbewerbe/51"
    },
    {
      "id": 53,
      "name": "Georgia",
      "link": "/wettbewerbe/national/wettbewerbe/53"
    },
    {
      "id": 40,
      "name": "Germany",
      "link": "/wettbewerbe/national/wettbewerbe/40"
    },
    {
      "id": 54,
      "name": "Ghana",
      "link": "/wettbewerbe/national/wettbewerbe/54"
    },
    {
      "id": 266,
      "name": "Gibraltar",
      "link": "/wettbewerbe/national/wettbewerbe/266"
    },
    {
      "id": 56,
      "name": "Greece",
      "link": "/wettbewerbe/national/wettbewerbe/56"
    },
    {
      "id": 243,
      "name": "Greenland",
      "link": "/wettbewerbe/national/wettbewerbe/243"
    },
    {
      "id": 55,
      "name": "Grenada",
      "link": "/wettbewerbe/national/wettbewerbe/55"
    },
    {
      "id": 251,
      "name": "Guadeloupe",
      "link": "/wettbewerbe/national/wettbewerbe/251"
    },
    {
      "id": 241,
      "name": "Guam",
      "link": "/wettbewerbe/national/wettbewerbe/241"
    },
    {
      "id": 58,
      "name": "Guatemala",
      "link": "/wettbewerbe/national/wettbewerbe/58"
    },
    {
      "id": 271,
      "name": "Guernsey",
      "link": "/wettbewerbe/national/wettbewerbe/271"
    },
    {
      "id": 59,
      "name": "Guinea",
      "link": "/wettbewerbe/national/wettbewerbe/59"
    },
    {
      "id": 60,
      "name": "Guinea-Bissau",
      "link": "/wettbewerbe/national/wettbewerbe/60"
    },
    {
      "id": 61,
      "name": "Guyana",
      "link": "/wettbewerbe/national/wettbewerbe/61"
    },
    {
      "id": 62,
      "name": "Haiti",
      "link": "/wettbewerbe/national/wettbewerbe/62"
    },
    {
      "id": 66,
      "name": "Honduras",
      "link": "/wettbewerbe/national/wettbewerbe/66"
    },
    {
      "id": 218,
      "name": "Hongkong",
      "link": "/wettbewerbe/national/wettbewerbe/218"
    },
    {
      "id": 178,
      "name": "Hungary",
      "link": "/wettbewerbe/national/wettbewerbe/178"
    },
    {
      "id": 73,
      "name": "Iceland",
      "link": "/wettbewerbe/national/wettbewerbe/73"
    },
    {
      "id": 67,
      "name": "India",
      "link": "/wettbewerbe/national/wettbewerbe/67"
    },
    {
      "id": 68,
      "name": "Indonesia",
      "link": "/wettbewerbe/national/wettbewerbe/68"
    },
    {
      "id": 71,
      "name": "Iran",
      "link": "/wettbewerbe/national/wettbewerbe/71"
    },
    {
      "id": 70,
      "name": "Iraq",
      "link": "/wettbewerbe/national/wettbewerbe/70"
    },
    {
      "id": 72,
      "name": "Ireland",
      "link": "/wettbewerbe/national/wettbewerbe/72"
    },
    {
      "id": 270,
      "name": "Isle of Man",
      "link": "/wettbewerbe/national/wettbewerbe/270"
    },
    {
      "id": 74,
      "name": "Israel",
      "link": "/wettbewerbe/national/wettbewerbe/74"
    },
    {
      "id": 75,
      "name": "Italy",
      "link": "/wettbewerbe/national/wettbewerbe/75"
    },
    {
      "id": 76,
      "name": "Jamaica",
      "link": "/wettbewerbe/national/wettbewerbe/76"
    },
    {
      "id": 77,
      "name": "Japan",
      "link": "/wettbewerbe/national/wettbewerbe/77"
    },
    {
      "id": 272,
      "name": "Jersey",
      "link": "/wettbewerbe/national/wettbewerbe/272"
    },
    {
      "id": 78,
      "name": "Jordan",
      "link": "/wettbewerbe/national/wettbewerbe/78"
    },
    {
      "id": 223,
      "name": "Jugoslawien (SFR)",
      "link": "/wettbewerbe/national/wettbewerbe/223"
    },
    {
      "id": 81,
      "name": "Kazakhstan",
      "link": "/wettbewerbe/national/wettbewerbe/81"
    },
    {
      "id": 82,
      "name": "Kenya",
      "link": "/wettbewerbe/national/wettbewerbe/82"
    },
    {
      "id": 246,
      "name": "Kiribati",
      "link": "/wettbewerbe/national/wettbewerbe/246"
    },
    {
      "id": 86,
      "name": "Korea, North",
      "link": "/wettbewerbe/national/wettbewerbe/86"
    },
    {
      "id": 87,
      "name": "Korea, South",
      "link": "/wettbewerbe/national/wettbewerbe/87"
    },
    {
      "id": 244,
      "name": "Kosovo",
      "link": "/wettbewerbe/national/wettbewerbe/244"
    },
    {
      "id": 89,
      "name": "Kuwait",
      "link": "/wettbewerbe/national/wettbewerbe/89"
    },
    {
      "id": 90,
      "name": "Kyrgyzstan",
      "link": "/wettbewerbe/national/wettbewerbe/90"
    },
    {
      "id": 91,
      "name": "Laos",
      "link": "/wettbewerbe/national/wettbewerbe/91"
    },
    {
      "id": 92,
      "name": "Latvia",
      "link": "/wettbewerbe/national/wettbewerbe/92"
    },
    {
      "id": 94,
      "name": "Lebanon",
      "link": "/wettbewerbe/national/wettbewerbe/94"
    },
    {
      "id": 93,
      "name": "Lesotho",
      "link": "/wettbewerbe/national/wettbewerbe/93"
    },
    {
      "id": 95,
      "name": "Liberia",
      "link": "/wettbewerbe/national/wettbewerbe/95"
    },
    {
      "id": 96,
      "name": "Libya",
      "link": "/wettbewerbe/national/wettbewerbe/96"
    },
    {
      "id": 97,
      "name": "Liechtenstein",
      "link": "/wettbewerbe/national/wettbewerbe/97"
    },
    {
      "id": 98,
      "name": "Lithuania",
      "link": "/wettbewerbe/national/wettbewerbe/98"
    },
    {
      "id": 99,
      "name": "Luxembourg",
      "link": "/wettbewerbe/national/wettbewerbe/99"
    },
    {
      "id": 219,
      "name": "Macao",
      "link": "/wettbewerbe/national/wettbewerbe/219"
    },
    {
      "id": 274,
      "name": "Macedonia",
      "link": "/wettbewerbe/national/wettbewerbe/274"
    },
    {
      "id": 101,
      "name": "Madagascar",
      "link": "/wettbewerbe/national/wettbewerbe/101"
    },
    {
      "id": 102,
      "name": "Malawi",
      "link": "/wettbewerbe/national/wettbewerbe/102"
    },
    {
      "id": 103,
      "name": "Malaysia",
      "link": "/wettbewerbe/national/wettbewerbe/103"
    },
    {
      "id": 104,
      "name": "Maldives",
      "link": "/wettbewerbe/national/wettbewerbe/104"
    },
    {
      "id": 105,
      "name": "Mali",
      "link": "/wettbewerbe/national/wettbewerbe/105"
    },
    {
      "id": 106,
      "name": "Malta",
      "link": "/wettbewerbe/national/wettbewerbe/106"
    },
    {
      "id": 257,
      "name": "Marshall Islands",
      "link": "/wettbewerbe/national/wettbewerbe/257"
    },
    {
      "id": 207,
      "name": "Martinique",
      "link": "/wettbewerbe/national/wettbewerbe/207"
    },
    {
      "id": 108,
      "name": "Mauritania",
      "link": "/wettbewerbe/national/wettbewerbe/108"
    },
    {
      "id": 109,
      "name": "Mauritius",
      "link": "/wettbewerbe/national/wettbewerbe/109"
    },
    {
      "id": 277,
      "name": "Mayotte",
      "link": "/wettbewerbe/national/wettbewerbe/277"
    },
    {
      "id": 110,
      "name": "Mexico",
      "link": "/wettbewerbe/national/wettbewerbe/110"
    },
    {
      "id": 112,
      "name": "Moldova",
      "link": "/wettbewerbe/national/wettbewerbe/112"
    },
    {
      "id": 113,
      "name": "Monaco",
      "link": "/wettbewerbe/national/wettbewerbe/113"
    },
    {
      "id": 114,
      "name": "Mongolia",
      "link": "/wettbewerbe/national/wettbewerbe/114"
    },
    {
      "id": 216,
      "name": "Montenegro",
      "link": "/wettbewerbe/national/wettbewerbe/216"
    },
    {
      "id": 235,
      "name": "Montserrat",
      "link": "/wettbewerbe/national/wettbewerbe/235"
    },
    {
      "id": 107,
      "name": "Morocco",
      "link": "/wettbewerbe/national/wettbewerbe/107"
    },
    {
      "id": 115,
      "name": "Mozambique",
      "link": "/wettbewerbe/national/wettbewerbe/115"
    },
    {
      "id": 116,
      "name": "Myanmar",
      "link": "/wettbewerbe/national/wettbewerbe/116"
    },
    {
      "id": 117,
      "name": "Namibia",
      "link": "/wettbewerbe/national/wettbewerbe/117"
    },
    {
      "id": 118,
      "name": "Nauru",
      "link": "/wettbewerbe/national/wettbewerbe/118"
    },
    {
      "id": 119,
      "name": "Nepal",
      "link": "/wettbewerbe/national/wettbewerbe/119"
    },
    {
      "id": 122,
      "name": "Netherlands",
      "link": "/wettbewerbe/national/wettbewerbe/122"
    },
    {
      "id": 227,
      "name": "Netherlands Antilles",
      "link": "/wettbewerbe/national/wettbewerbe/227"
    },
    {
      "id": 255,
      "name": "Netherlands East India",
      "link": "/wettbewerbe/national/wettbewerbe/255"
    },
    {
      "id": 236,
      "name": "Neukaledonien",
      "link": "/wettbewerbe/national/wettbewerbe/236"
    },
    {
      "id": 120,
      "name": "New Zealand",
      "link": "/wettbewerbe/national/wettbewerbe/120"
    },
    {
      "id": 121,
      "name": "Nicaragua",
      "link": "/wettbewerbe/national/wettbewerbe/121"
    },
    {
      "id": 123,
      "name": "Niger",
      "link": "/wettbewerbe/national/wettbewerbe/123"
    },
    {
      "id": 124,
      "name": "Nigeria",
      "link": "/wettbewerbe/national/wettbewerbe/124"
    },
    {
      "id": 261,
      "name": "Niue",
      "link": "/wettbewerbe/national/wettbewerbe/261"
    },
    {
      "id": 100,
      "name": "North Macedonia",
      "link": "/wettbewerbe/national/wettbewerbe/100"
    },
    {
      "id": 192,
      "name": "Northern Ireland",
      "link": "/wettbewerbe/national/wettbewerbe/192"
    },
    {
      "id": 268,
      "name": "Northern Mariana Islands",
      "link": "/wettbewerbe/national/wettbewerbe/268"
    },
    {
      "id": 125,
      "name": "Norway",
      "link": "/wettbewerbe/national/wettbewerbe/125"
    },
    {
      "id": 126,
      "name": "Oman",
      "link": "/wettbewerbe/national/wettbewerbe/126"
    },
    {
      "id": 128,
      "name": "Pakistan",
      "link": "/wettbewerbe/national/wettbewerbe/128"
    },
    {
      "id": 129,
      "name": "Palau",
      "link": "/wettbewerbe/national/wettbewerbe/129"
    },
    {
      "id": 240,
      "name": "Palestine",
      "link": "/wettbewerbe/national/wettbewerbe/240"
    },
    {
      "id": 130,
      "name": "Panama",
      "link": "/wettbewerbe/national/wettbewerbe/130"
    },
    {
      "id": 131,
      "name": "Papua New Guinea",
      "link": "/wettbewerbe/national/wettbewerbe/131"
    },
    {
      "id": 132,
      "name": "Paraguay",
      "link": "/wettbewerbe/national/wettbewerbe/132"
    },
    {
      "id": 259,
      "name": "People's republic of the Congo",
      "link": "/wettbewerbe/national/wettbewerbe/259"
    },
    {
      "id": 133,
      "name": "Peru",
      "link": "/wettbewerbe/national/wettbewerbe/133"
    },
    {
      "id": 134,
      "name": "Philippines",
      "link": "/wettbewerbe/national/wettbewerbe/134"
    },
    {
      "id": 135,
      "name": "Poland",
      "link": "/wettbewerbe/national/wettbewerbe/135"
    },
    {
      "id": 136,
      "name": "Portugal",
      "link": "/wettbewerbe/national/wettbewerbe/136"
    },
    {
      "id": 228,
      "name": "Puerto Rico",
      "link": "/wettbewerbe/national/wettbewerbe/228"
    },
    {
      "id": 137,
      "name": "Qatar",
      "link": "/wettbewerbe/national/wettbewerbe/137"
    },
    {
      "id": 249,
      "name": "Réunion",
      "link": "/wettbewerbe/national/wettbewerbe/249"
    },
    {
      "id": 140,
      "name": "Romania",
      "link": "/wettbewerbe/national/wettbewerbe/140"
    },
    {
      "id": 141,
      "name": "Russia",
      "link": "/wettbewerbe/national/wettbewerbe/141"
    },
    {
      "id": 139,
      "name": "Rwanda",
      "link": "/wettbewerbe/national/wettbewerbe/139"
    },
    {
      "id": 263,
      "name": "Saarland",
      "link": "/wettbewerbe/national/wettbewerbe/263"
    },
    {
      "id": 267,
      "name": "Saint-Martin",
      "link": "/wettbewerbe/national/wettbewerbe/267"
    },
    {
      "id": 143,
      "name": "Samoa",
      "link": "/wettbewerbe/national/wettbewerbe/143"
    },
    {
      "id": 144,
      "name": "San Marino",
      "link": "/wettbewerbe/national/wettbewerbe/144"
    },
    {
      "id": 145,
      "name": "Sao Tome and Principe",
      "link": "/wettbewerbe/national/wettbewerbe/145"
    },
    {
      "id": 146,
      "name": "Saudi Arabia",
      "link": "/wettbewerbe/national/wettbewerbe/146"
    },
    {
      "id": 190,
      "name": "Scotland",
      "link": "/wettbewerbe/national/wettbewerbe/190"
    },
    {
      "id": 149,
      "name": "Senegal",
      "link": "/wettbewerbe/national/wettbewerbe/149"
    },
    {
      "id": 215,
      "name": "Serbia",
      "link": "/wettbewerbe/national/wettbewerbe/215"
    },
    {
      "id": 150,
      "name": "Serbia and Montenegro",
      "link": "/wettbewerbe/national/wettbewerbe/150"
    },
    {
      "id": 151,
      "name": "Seychelles",
      "link": "/wettbewerbe/national/wettbewerbe/151"
    },
    {
      "id": 152,
      "name": "Sierra Leone",
      "link": "/wettbewerbe/national/wettbewerbe/152"
    },
    {
      "id": 153,
      "name": "Singapore",
      "link": "/wettbewerbe/national/wettbewerbe/153"
    },
    {
      "id": 265,
      "name": "Sint Maarten",
      "link": "/wettbewerbe/national/wettbewerbe/265"
    },
    {
      "id": 154,
      "name": "Slovakia",
      "link": "/wettbewerbe/national/wettbewerbe/154"
    },
    {
      "id": 155,
      "name": "Slovenia",
      "link": "/wettbewerbe/national/wettbewerbe/155"
    },
    {
      "id": 69,
      "name": "Solomon Islands",
      "link": "/wettbewerbe/national/wettbewerbe/69"
    },
    {
      "id": 156,
      "name": "Somalia",
      "link": "/wettbewerbe/national/wettbewerbe/156"
    },
    {
      "id": 159,
      "name": "South Africa",
      "link": "/wettbewerbe/national/wettbewerbe/159"
    },
    {
      "id": 262,
      "name": "Southern Sudan",
      "link": "/wettbewerbe/national/wettbewerbe/262"
    },
    {
      "id": 157,
      "name": "Spain",
      "link": "/wettbewerbe/national/wettbewerbe/157"
    },
    {
      "id": 158,
      "name": "Sri Lanka",
      "link": "/wettbewerbe/national/wettbewerbe/158"
    },
    {
      "id": 225,
      "name": "St. Kitts & Nevis",
      "link": "/wettbewerbe/national/wettbewerbe/225"
    },
    {
      "id": 230,
      "name": "St. Lucia",
      "link": "/wettbewerbe/national/wettbewerbe/230"
    },
    {
      "id": 224,
      "name": "St. Vincent & Grenadinen",
      "link": "/wettbewerbe/national/wettbewerbe/224"
    },
    {
      "id": 160,
      "name": "Sudan",
      "link": "/wettbewerbe/national/wettbewerbe/160"
    },
    {
      "id": 161,
      "name": "Suriname",
      "link": "/wettbewerbe/national/wettbewerbe/161"
    },
    {
      "id": 273,
      "name": "Swaziland",
      "link": "/wettbewerbe/national/wettbewerbe/273"
    },
    {
      "id": 147,
      "name": "Sweden",
      "link": "/wettbewerbe/national/wettbewerbe/147"
    },
    {
      "id": 148,
      "name": "Switzerland",
      "link": "/wettbewerbe/national/wettbewerbe/148"
    },
    {
      "id": 163,
      "name": "Syria",
      "link": "/wettbewerbe/national/wettbewerbe/163"
    },
    {
      "id": 237,
      "name": "Tahiti",
      "link": "/wettbewerbe/national/wettbewerbe/237"
    },
    {
      "id": 165,
      "name": "Tajikistan",
      "link": "/wettbewerbe/national/wettbewerbe/165"
    },
    {
      "id": 166,
      "name": "Tanzania",
      "link": "/wettbewerbe/national/wettbewerbe/166"
    },
    {
      "id": 167,
      "name": "Thailand",
      "link": "/wettbewerbe/national/wettbewerbe/167"
    },
    {
      "id": 52,
      "name": "The Gambia",
      "link": "/wettbewerbe/national/wettbewerbe/52"
    },
    {
      "id": 245,
      "name": "Tibet",
      "link": "/wettbewerbe/national/wettbewerbe/245"
    },
    {
      "id": 242,
      "name": "Timor-Leste",
      "link": "/wettbewerbe/national/wettbewerbe/242"
    },
    {
      "id": 168,
      "name": "Togo",
      "link": "/wettbewerbe/national/wettbewerbe/168"
    },
    {
      "id": 169,
      "name": "Tonga",
      "link": "/wettbewerbe/national/wettbewerbe/169"
    },
    {
      "id": 170,
      "name": "Trinidad and Tobago",
      "link": "/wettbewerbe/national/wettbewerbe/170"
    },
    {
      "id": 173,
      "name": "Tunisia",
      "link": "/wettbewerbe/national/wettbewerbe/173"
    },
    {
      "id": 174,
      "name": "Türkiye",
      "link": "/wettbewerbe/national/wettbewerbe/174"
    },
    {
      "id": 175,
      "name": "Turkmenistan",
      "link": "/wettbewerbe/national/wettbewerbe/175"
    },
    {
      "id": 226,
      "name": "Turks- and Caicosinseln",
      "link": "/wettbewerbe/national/wettbewerbe/226"
    },
    {
      "id": 247,
      "name": "Tuvalu",
      "link": "/wettbewerbe/national/wettbewerbe/247"
    },
    {
      "id": 221,
      "name": "UdSSR",
      "link": "/wettbewerbe/national/wettbewerbe/221"
    },
    {
      "id": 176,
      "name": "Uganda",
      "link": "/wettbewerbe/national/wettbewerbe/176"
    },
    {
      "id": 177,
      "name": "Ukraine",
      "link": "/wettbewerbe/national/wettbewerbe/177"
    },
    {
      "id": 183,
      "name": "United Arab Emirates",
      "link": "/wettbewerbe/national/wettbewerbe/183"
    },
    {
      "id": 264,
      "name": "United Kingdom",
      "link": "/wettbewerbe/national/wettbewerbe/264"
    },
    {
      "id": 184,
      "name": "United States",
      "link": "/wettbewerbe/national/wettbewerbe/184"
    },
    {
      "id": 179,
      "name": "Uruguay",
      "link": "/wettbewerbe/national/wettbewerbe/179"
    },
    {
      "id": 180,
      "name": "Uzbekistan",
      "link": "/wettbewerbe/national/wettbewerbe/180"
    },
    {
      "id": 181,
      "name": "Vanuatu",
      "link": "/wettbewerbe/national/wettbewerbe/181"
    },
    {
      "id": 256,
      "name": "Vatican",
      "link": "/wettbewerbe/national/wettbewerbe/256"
    },
    {
      "id": 182,
      "name": "Venezuela",
      "link": "/wettbewerbe/national/wettbewerbe/182"
    },
    {
      "id": 185,
      "name": "Vietnam",
      "link": "/wettbewerbe/national/wettbewerbe/185"
    },
    {
      "id": 191,
      "name": "Wales",
      "link": "/wettbewerbe/national/wettbewerbe/191"
    },
    {
      "id": 275,
      "name": "Western Sahara",
      "link": "/wettbewerbe/national/wettbewerbe/275"
    },
    {
      "id": 186,
      "name": "Yemen",
      "link": "/wettbewerbe/national/wettbewerbe/186"
    },
    {
      "id": 258,
      "name": "Yugoslavia (Republic)",
      "link": "/wettbewerbe/national/wettbewerbe/258"
    },
    {
      "id": 254,
      "name": "Zaire",
      "link": "/wettbewerbe/national/wettbewerbe/254"
    },
    {
      "id": 142,
      "name": "Zambia",
      "link": "/wettbewerbe/national/wettbewerbe/142"
    },
    {
      "id": 253,
      "name": "Zanzibar",
      "link": "/wettbewerbe/national/wettbewerbe/253"
    },
    {
      "id": 187,
      "name": "Zimbabwe",
      "link": "/wettbewerbe/national/wettbewerbe/187"
    }
  ]